<!-- Modal Backdrop -->
@if (isOpen) {
  <div
    #modalBackdrop
    class="fixed w-full inset-0 z-50 flex items-center justify-center p-2 sm:p-4 bg-black bg-black/50"
    (click)="onBackdropClick($event)"
    >
    <!-- Modal Container -->
    <div
      #modalContainer
      class="relative w-full {{ getModalSizeClass() }} bg-white rounded-lg shadow-xl transform transition-all mx-auto modal-container"
      (click)="$event.stopPropagation()"
      >
      <!-- Modal Header -->
      <div class="flex items-center justify-between p-6 border-b border-gray-200">
        <h3 class="text-lg font-semibold text-gray-900">
          {{ config.title }}
        </h3>
        <!-- Close Button -->
        @if (config.showCloseButton) {
          <button
            type="button"
            class="text-gray-400 hover:text-gray-600 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-300 rounded-md p-1"
            (click)="closeModal()"
            >
            <mat-icon class="w-5 h-5">close</mat-icon>
          </button>
        }
      </div>
      <!-- Modal Body -->
      <div class="p-6">
        <!-- Custom Content Projection -->
        @if (customContent) {
          <div class="modal-content">
            <ng-content></ng-content>
          </div>
        }
        <!-- Default Text Content -->
        @if (!customContent && config.content) {
          <div class="text-gray-700 leading-relaxed">
            {{ config.content }}
          </div>
        }
      </div>
      <!-- Modal Footer -->
      @if (config.buttons && config.buttons.length > 0) {
        <div
          class="flex items-center justify-end gap-3 p-6 border-t border-gray-200 bg-gray-50 rounded-b-lg modal-footer"
          >
          @for (button of config.buttons; track button) {
            <button
              type="button"
              [class]="getButtonClass(button)"
              [disabled]="button.disabled || button.loading"
              (click)="onButtonClick(button.action)"
              >
              <!-- Loading Spinner -->
              @if (button.loading) {
                <div
                  class="inline-flex items-center mr-2"
                  >
                  <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                </div>
              }
              {{ button.text }}
            </button>
          }
        </div>
      }
    </div>
  </div>
}
